import React from "react";
import strings from "../Language";
import { images } from "../../config/image";

class SubHeader extends React.Component {
    constructor(props) {
        super(props);
        var headerData = (this.props && this.props.data) ? this.props.data : {};
        var headerTitle = (this.props && this.props.data && this.props.data.title) ? this.props.data.title : "";
        this.state = {
            lang: strings.getLanguage(),
            headerData: headerData,
            headerTitle: headerTitle,
        }
    }

    async componentDidMount() {
        window.scrollTo(0, 0);

        var headerTitle = (this.state.headerTitle && this.state.headerTitle != '') ? " | " + this.state.headerTitle : "";
        document.title = "AKLighting" + headerTitle;
    }

    /**
     * Change Language
     * @param {string} obj 
     */
    changeLanguage(lang) {
        if (lang) {
            strings.setLanguage(lang);
            localStorage.setItem("language", lang);
            this.setState({ lang: lang });
            window.location.reload();
        }
    }

    handleGoBack = () => {
        if (window.history.length > 1) {
            window.history.back(); // Go back to the previous page
        } else {
            window.location.href = '/'; // Redirect to home or a default page
        }
    };

    render() {
        return (
            <>
                <header className="sub-header">
                    <div onClick={this.handleGoBack} id="backButton" className="back-button">
                        <img src={images['arrow-back-icon']} alt="" />
                    </div>

                    <h1 id="faqText" className="main-title">{this.state.headerTitle}</h1>
                    <div className="last-button"></div>
                </header>
            </>
        );
    }
}

export default SubHeader;